import Reactions from 'hb-react/frontoffice/components/Reactions';
import { useTogglePostLike } from 'hb-react/shared/apps/News/NewsPublished/hooks/useTogglePostLike';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

const NewsReactions = ({ id, likes }) => {
  const { togglePostLike } = useTogglePostLike();
  const { flagEvNewsRevamp } = useFeatureFlag();
  const railsType = flagEvNewsRevamp ? 'Communications::News' : 'Communication';

  return (
    <Reactions
      key={id}
      displayCommentsByDefault
      id={id}
      initialLikes={likes}
      onTogglePostLike={togglePostLike}
      type={railsType}
      railsType={railsType}
    />
  );
};

export default NewsReactions;
